import { usePermissionsQuery } from "graphql/generated";
import ParentDashboard from "./parent/ParentDashboard";
import AdminDashboard from "./admin";
import { useAppContexts } from "hooks/use-context";
import LiteDashboard from "./lite";
import AdminDashboardLegacy from "./legacy";
import { TIER3 } from "../../constants";

function Dashboard() {
  const { user, program } = useAppContexts();
  const { loading } = usePermissionsQuery();

  return (
    <>
      {loading ? (
        <div>Loading</div>
      ) : (
        <>
          {user?.isParent() ? (
            <ParentDashboard />
          ) : (
            <>
              {program?.isLite && program.tier !== TIER3 && <LiteDashboard />}
              {(!program?.isLite || program.tier === TIER3) && (
                <>
                  {!user?.isLegacyDashboard() && <AdminDashboard />}
                  {user?.isLegacyDashboard() && <AdminDashboardLegacy />}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

export default Dashboard;
